import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class CrmBrandSourceXrefService {
  private readonly baseUrl = '/api/crm/brand-source-xref';

  constructor(
    private httpService: HttpService,
    private constantsService: ConstantsService
  ) {}

  getXrefs(clientKey?: number, brandKey?: number): Observable<any> {
    const params: string[] = [];
    if (clientKey) { params.push(`clientKey=${clientKey}`); }
    if (brandKey) { params.push(`brandKey=${brandKey}`); }
    const url = params.length ? `${this.baseUrl}?${params.join('&')}` : this.baseUrl;
    const requestData = {
      API_URL: url,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  linkSource(xrefPayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST,
      BODY: xrefPayload
    };
    return this.httpService.sendRequest(requestData);
  }

  updateXref(id: number, xrefPayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_PUT,
      BODY: xrefPayload
    };
    return this.httpService.sendRequest(requestData);
  }

  unlinkSource(id: number): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_DELETE
    };
    return this.httpService.sendRequest(requestData);
  }
}
